import React, { useState, useEffect } from "react";
import CRMInputLabelAndErrorWrapComponent from "../CRMInputLabelAndErrorWrapComponent/CRMInputLabelAndErrorWrapComponent";
import CRMInputGeneralComponent from "../CRMInputs/CRMInputGeneralComponent/CRMInputGeneralComponent";
import { parseMortgageTerm, formatMortgageTerm } from "../../functions/mortgageTerm";

export interface ICRMMortgageTermFormInputProps {
    onChange: (value: number | null) => void;
    model: number | null;
    displayError: boolean;
    disabled?: boolean;
    label: string;
}

export const CRMMortgageTermFormInput = (props: ICRMMortgageTermFormInputProps): JSX.Element => {
    const [inputValue, setInputValue] = useState<string>("");
    const [localError, setLocalError] = useState<string | null>(null);

    const label = props.label.replace(/ months$/i, "");

    useEffect(() => {
        setInputValue(formatMortgageTerm(props.model));
    }, [props.model]);

    const handleBlur = () => {
        const text = inputValue.trim();
        if (text === "") {
            setLocalError(null);
            props.onChange(null);
            return;
        }

        const parsed = parseMortgageTerm(text);

        if (!parsed.isValid) {
            setLocalError("We couldn't read that. Try 2 years 5 months, or 29 months.");
            return;
        }

        if (parsed.years === 0 && parsed.months === 0) {
            setLocalError(null);
            props.onChange(null);
        } else {
            setLocalError(null);
            props.onChange(parsed.years * 12 + parsed.months);
        }
    };

    return (
        <CRMInputLabelAndErrorWrapComponent 
            label={label}
            errorMessage={localError || undefined}
            displayError={props.displayError || !!localError}
        >
            <CRMInputGeneralComponent
                inputType="text"
                value={inputValue}
                onChange={(val) => {
                    setInputValue(val);
                    if (localError) setLocalError(null); // Clear error while typing
                }}
                onBlur={handleBlur}
                placeholder="2 years 5 months"
                disabled={props.disabled}
                displayError={props.displayError || !!localError}
            />
        </CRMInputLabelAndErrorWrapComponent>
    );
};
